// Sentence case: only the first letter of the whole string capitalized, rest lowercase
export const toSentenceCase = (text) => {
  if (!text) return '';
  const lower = String(text).trim().toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
};

// Strips common Portuguese legal-entity suffixes (Lda, Lda., S.A., Unipessoal, etc.) from a
// company's full legal name, so sales tables can show a cleaner commercial name instead of
// the whole legal name. Case-insensitive; safe no-op if no suffix is found.
export const shortenCompanyName = (rawName) => {
  if (!rawName) return '';
  let name = String(rawName).trim();
  name = name.replace(/,?\s*(unipessoal\s*,?\s*)?(lda\.?|s\.?a\.?)\s*$/i, '').trim();
  return toSentenceCase(name || rawName);
};

// Strips the leading product code (e.g. "GP 0625", "GPR0899", "GM 0511") from a GPP
// material description, keeping just the product name + measure, then applies sentence case.
// "GP 0625 RORIZ BEGE 30X60" -> "Roriz bege 30x60"
export const cleanProductName = (material) => {
  if (!material) return '';
  const withoutCode = String(material).replace(/^[A-Z]{1,4}\s*\d{3,6}\s*/i, '').trim();
  return toSentenceCase(withoutCode || material);
};
